import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { type ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
  withViewTransitions,
} from '@angular/router';

import { authInterceptor, provideAuth } from '@core/auth';
import { provideI18n } from '@core/i18n';
import { provideLog } from '@core/log';
import { NavPreloadStrategy, provideNav } from '@core/nav';

import { provideDialog } from '@shared/dialog';
import { provideMask } from '@shared/mask';
import { provideMenu } from '@shared/menu';
import { providePopover } from '@shared/popover';
import { provideSelect } from '@shared/select';
import { provideTabGroup } from '@shared/tab-group';
import { provideToast } from '@shared/toast';
import { provideTooltip } from '@shared/tooltip';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withPreloading(NavPreloadStrategy),
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withViewTransitions({ skipInitialTransition: true }),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAuth(),
    provideNav(),
    provideI18n(),
    provideLog(),
    provideMask(),
    provideMenu(),
    providePopover(),
    provideTooltip(),
    provideToast(),
    provideSelect(),
    provideDialog(),
    provideTabGroup(),
  ],
};
